import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `GrupoUsuario/index`, method: 'GET', body: null})
}